export const footerTranslations = {
  en: {
    workWithUs: 'work with us',
    defaultContent:
      'We are eager to learn about your organization and to help you achieve a well defined and consistent strategy.',
    privacyPolicy: 'Privacy Policy',
    copyright: '©{year} the.good.code; All rights reserved.'
  },
  de: {
    workWithUs: 'Arbeiten Sie mit uns',
    defaultContent:
      'Wir freuen uns darauf Ihr, Unternehmen kennenzulernen und Sie bei der Entwicklung einer wohl definierten und nachhaltigen Strategie zu unterstützen.',
    privacyPolicy: 'Datenschutz',
    copyright: '©{year} the.good.code; Alle Rechte vorbehalten.'
  }
}
